import { isNativePlatform } from './platform';

/**
 * Whether self-serve payment initiation (Stripe checkout, customer portal,
 * subscription enrollment, ticket purchase) is allowed in the current runtime.
 *
 * Disabled inside the native iOS / Android app: App Store Review Guideline
 * 3.1.1 forbids steering users to non-Apple purchase flows for digital goods,
 * and the product MVP scope makes mobile billing READ-ONLY (balances, charges,
 * tickets and seat maps stay visible; only the action that *starts* a payment
 * is removed). Practically this also avoids the broken native path: checkout /
 * portal / ticket flows build their success/cancel/return URLs from
 * `window.location.origin`, which is `capacitor://localhost` on device, and the
 * edge function rejects non-http(s) URLs — so initiating a payment natively
 * 400s anyway.
 *
 * Returns `true` on the web, where checkout works normally.
 *
 * TODO: replace this platform check with a real entitlement / store-payment
 * check once App Store payment compliance (e.g. StoreKit) is resolved.
 */
export function arePaymentsEnabled(): boolean {
  return !isNativePlatform();
}
